import {
  OPEN_REPORT_ASSET_FEED,
  CLOSE_REPORT_ASSET_FEED,
} from 'constants/actions';

const initialState = {
  assetsModalIsOpen: false,
  currentEditingPosition: null,
};

export default function settings(state = initialState, action) {
  switch (action.type) {
    case OPEN_REPORT_ASSET_FEED:
      return {
        ...state,
        assetsModalIsOpen: action.assetsModalIsOpen,
        currentEditingPosition: action.currentEditingPosition,
      };
    case CLOSE_REPORT_ASSET_FEED:
      return {
        ...state,
        assetsModalIsOpen: action.assetsModalIsOpen,
        currentEditingPosition: action.currentEditingPosition,
      };

    default:
      return state;
  }
}
